module.exports = __webpack_public_path__ + "static/ground-02a2a35b7afd795b419b4f22e7945f23.jpg";